function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 511.992 511.992",
  style: {
    "enableBackground": "new 0 0 511.992 511.992"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#3E4347"
  },
  d: "M317.308,84.304H293.5c0-60.512-19.936-60.512-37.52-60.512s-37.52,0-37.52,60.512h-23.808 C194.668,34.48,206.716,0,255.996,0C305.34,0,317.308,34.576,317.308,84.304z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#5A5F63"
  },
  d: "M457.852,390.032c-4.544-41.648-17.68-75.856-39.472-75.856h-12.048v151.328 c3.648,0.256,7.648,0.384,12.048,0.384C454.364,465.888,464.172,448.096,457.852,390.032z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#5A5F63"
  },
  d: "M54.14,390.032c4.544-41.648,17.68-75.856,39.472-75.856h12.048v151.328 c-3.648,0.256-7.648,0.384-12.048,0.384C57.628,465.888,47.82,448.096,54.14,390.032z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#5A5F63"
  },
  d: "M415.18,460.384c-0.464,21.984-16.848,40.4-38.64,43.376c-80.336,10.976-160.752,10.976-241.104,0 c-21.792-2.976-38.176-21.392-38.64-43.376c-1.92-91.008,1.952-178.864,9.552-261.488c16.608-180.8,282.656-180.96,299.296,0 C413.228,281.52,417.116,369.376,415.18,460.384z"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#3E4347"
  },
  d: "M418.364,465.888c-1.248,0-2.464-0.016-3.632-0.032c-2.816,19.504-18.24,35.184-38.192,37.904 c-80.336,10.976-160.752,10.976-241.104,0c-14.384-1.968-26.416-10.656-33.056-22.656c19.344,7.472,39.792,11.488,60.96,11.488 c120.16,0,217.568-129.264,217.568-288.704c0-32.128-3.952-63.024-11.248-91.872c19.328,21.712,32.656,50.688,35.968,86.896 c3.44,37.424,6.112,75.904,7.84,115.28h4.896c21.792,0,34.928,34.208,39.472,75.856 C464.172,448.096,454.364,465.888,418.364,465.888z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#65B1EF"
  },
  d: "M415.18,460.384c1.2-56.544,0.16-111.856-2.624-165.472c-18.224,5.312-31.984,21.344-33.888,41.136 c-8.24,85.408-57.136,109.44-121.152,109.696h-3.04c-63.968-0.256-112.864-24.464-121.136-109.712 c-1.92-19.792-15.68-35.824-33.904-41.136c-2.784,53.6-3.824,108.928-2.624,165.472c0.464,21.984,16.848,40.4,38.64,43.376 c2.976,0.4,5.952,0.8,8.928,1.168c25.68-19.616,66.112-32.272,111.616-32.272s85.936,12.656,111.616,32.272 c2.976-0.384,5.952-0.768,8.928-1.168C398.332,500.784,414.716,482.368,415.18,460.384z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#65B1EF"
  },
  d: "M361.02,335.488c-0.048,1.776-0.176,3.552-0.4,5.312c-8.256,65.248-42.464,87.552-106.112,87.552 c-63.616-0.272-95.376-25.744-103.152-87.984c-0.192-1.6-0.304-3.216-0.352-4.832c-0.384-14.672-2.144-91.6,1.6-132.384 c5.872-63.936,54.176-93.472,103.44-93.472c47.776,0,97.344,28.112,103.36,93.472C363.132,243.888,361.404,320.72,361.02,335.488z"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFFFFF"
  },
  d: "M330.556,185.28c0.64,2.08-0.48,4.32-2.72,4.96c-1.408,0.688-4.304-0.144-4.96-2.56 c-9.392-30.16-36.272-44.96-66.88-44.96c-30.16,0-57.248,14.48-66.88,44.96c-0.64,2.08-3.04,3.2-4.96,2.56 c-2.24-0.64-3.36-2.88-2.72-4.96c10.48-33.376,40.448-50.56,74.56-50.56C289.772,134.72,319.58,151.184,330.556,185.28z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#3E4347"
  },
  d: "M273.228,140.976c-6.32,0-11.44,20.368-11.44,26.672c0,6.32,5.12,11.44,11.44,11.44 s11.44-5.12,11.44-11.44C284.668,161.328,279.532,140.976,273.228,140.976z M273.228,173.872c-3.28,0-5.936-2.752-6.128-6.208h12.24 C279.164,171.12,276.492,173.872,273.228,173.872z"
}), /*#__PURE__*/React.createElement("g", {
  style: {
    "opacity": 0.2
  }
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFFFFF"
  },
  d: "M339.788,96.128c0,159.456-97.408,288.72-217.568,288.72c-22.784,0-44.752-4.656-65.392-13.28 c6.08-32.832,18.32-57.392,36.784-57.392h4.896c0.048-1.12,0.096-2.256,0.144-3.376c0.08-1.584,0.144-3.184,0.224-4.768 c0.08-1.616,0.16-3.216,0.24-4.816c0.08-1.936,0.192-3.856,0.288-5.776c0.016-0.176,0.016-0.352,0.032-0.528 c1.696-32.672,4.048-64.72,6.912-96.016c5.84-63.616,42.576-104.88,88.464-123.744C196.316,30.32,209.788,0,255.996,0 c46.256,0,59.664,30.368,61.168,75.136c7.808,3.2,15.344,7.056,22.496,11.552C339.74,89.824,339.788,92.976,339.788,96.128z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#4E99D2"
  },
  d: "M135.452,503.76c2.976,0.4,5.952,0.8,8.928,1.168c5.904-4.512,12.608-8.656,19.952-12.352 c-0.336,0-0.656,0-0.976,0c-21.152,0-41.616-4.016-60.944-11.488C109.036,493.104,121.068,501.792,135.452,503.76z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#4E99D2"
  },
  d: "M255.996,472.672c45.504,0,85.936,12.656,111.616,32.272c2.976-0.384,5.952-0.768,8.928-1.168 c21.792-2.976,38.176-21.392,38.64-43.376c1.2-56.544,0.16-111.856-2.624-165.472c-18.224,5.312-31.984,21.344-33.888,41.136 c-7.056,73.12-43.936,101.264-94.56,108c-13.056,11.584-27.12,21.344-41.968,29.008C246.7,472.816,251.324,472.672,255.996,472.672 z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#4E99D2"
  },
  d: "M360.62,340.8c0.224-1.76,0.368-3.536,0.4-5.312c0.064-2.384,0.16-6.4,0.256-11.6 c-12.832,37.184-31.424,70.128-54.272,96.816C337.516,409.488,355.02,385.008,360.62,340.8z"
})), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/backpack.afd116e8.svg";
export { SvgComponent as ReactComponent };